import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_6 = { class: "dataTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!

  return (!_ctx.displayModalChoixSite)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.title')) + " ", 1),
            _createVNode(_component_ReglePastille, { cle: "interventionNonPreventive.definition" })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.isUniqueSite)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "suiviInterventionsNonPreventives.filtreSiteUnique" }),
                  _createVNode(_component_ButtonBlue, {
                    disabled: _ctx.tableData.length === 0 && _ctx.isLoading,
                    "on-click": _ctx.selectionnerSite,
                    text: _ctx.$t('bouton.choix.site'),
                    class: "button-confirm btn"
                  }, null, 8, ["disabled", "on-click", "text"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Filter, {
              filter: this.filter,
              siteList: this.siteList,
              statusList: this.statusList,
              class: "filter",
              onAddFilterStatus: this.addFilterStatus,
              onClearFilter: this.clearFilter,
              onRemoveFilterStatus: this.removeFilterStatus,
              onSearch: _ctx.search,
              onSetInterventionId: this.setInterventionId,
              onSetPredictedDateFrom: this.setPredictedDateFrom,
              onSetPredictedDateTo: this.setPredictedDateTo,
              onStatusToggleSelectAll: this.statusToggleSelectAll
            }, null, 8, ["filter", "siteList", "statusList", "onAddFilterStatus", "onClearFilter", "onRemoveFilterStatus", "onSearch", "onSetInterventionId", "onSetPredictedDateFrom", "onSetPredictedDateTo", "onStatusToggleSelectAll"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(this.count) + " " + _toDisplayString(_ctx.$t('intervention.non-preventive.dataTable.title')) + " ", 1),
                _createVNode(_component_ReglePastille, { cle: "suiviInterventionsNonPreventives.portee" }),
                _createVNode(_component_ReglePastille, { cle: "suiviInterventionsNonPreventives.selectionTout" })
              ]),
              (!_ctx.isExportDisabled)
                ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                    key: 0,
                    imgUrl: _ctx.iconeXls,
                    title: _ctx.$t('list.export'),
                    onClick: _ctx.exportXls
                  }, null, 8, ["imgUrl", "title", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ReglePastille, { cle: "suiviInterventionsNonPreventives.exporterActif" })
            ]),
            (_ctx.tableData.length === 0 && _ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                  key: 0,
                  class: "loader"
                }))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref: "content",
                  class: "datatable-container",
                  onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                }, [
                  _createVNode(_component_DataTable, {
                    count: +_ctx.count,
                    isLoading: _ctx.isLoading,
                    "stop-propa-on-pdf": true,
                    tableData: this.tableData,
                    tableHeader: this.tableHeader,
                    onDownloadPdf: _ctx.downloadPdf,
                    onSelect: _ctx.goToPage,
                    onSort: _ctx.doSort
                  }, null, 8, ["count", "isLoading", "tableData", "tableHeader", "onDownloadPdf", "onSelect", "onSort"])
                ], 544))
          ]),
          (_ctx.isExportXlsLoading)
            ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_ModalChoixSite, {
        key: 1,
        "is-multi-site": true,
        "inclure-termines": true,
        "selected-site": null,
        "selected-sites": _ctx.filter.siteList,
        onCancel: _ctx.modalChoixSiteCancel,
        onValider: _ctx.validerSite
      }, null, 8, ["selected-sites", "onCancel", "onValider"]))
}